import { datadogRum } from '@datadog/browser-rum';
import BrowserCookies from './BrowserCookies';

type Context = {
  location: string;
  [key: string]: any;
};

export type Options = {
  callback?: (_: Error) => void;
  controller?: AbortController;
};

const isLocalDevEnvironment = Boolean(process.env.IS_LOCAL);

function logToConsole(error: Error, context?: Context) {
  // eslint-disable-next-line no-console
  console.error({
    message: error.message,
    stack: error.stack,
    context
  });
}

function logToTelemetry(error: Error, context?: Context) {
  datadogRum.addError(error, context);
}

export const logError = (
  error: Error,
  context?: Context,
  options?: Options
) => {
  const { callback, controller } = options ?? {};

  // Ignore aborts because the call likely happened again immediately after
  if (controller?.signal?.aborted) return;

  if (isLocalDevEnvironment) {
    logToConsole(error, context);
  } else {
    logToTelemetry(error, context);
  }

  if (callback) callback(error);
};

export function toError(err: unknown) {
  return err instanceof Error ? err : new Error(String(err));
}

const generateErrorLogger =
  (location: string, globalContext?: Partial<Context>, options?: Options) =>
  (error: Error, instanceContext?: Partial<Context>) =>
    logError(
      error,
      {
        location,
        ...globalContext,
        ...instanceContext,
        BrowserCookieId: BrowserCookies.get('BrowserCookieId') || '',
        fullStoryId: BrowserCookies.get('fs_uid') || '',
        url: window.location.href
      },
      options
    );

export default generateErrorLogger;
